export enum Alignment {
    Start,
    End,
    Center,
}
